import { Component, Input, OnInit } from '@angular/core';
import { ReportOutputTypes } from '../reports.models';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'report-list-btn',
  templateUrl: './list-btn.component.html',
  styleUrls: ['./list-btn.component.scss']
})
export class ListBtnComponent implements OnInit {
  @Input('reportCode') reportCode: string;
  @Input('url') url: string;
  @Input('filter') filter: string;
  @Input('sort') sort: string;

  downloadFormats = [
    { value: "pdf", name: "PDF", icon: "exportpdf" },
    { value: "xls", name: "XLS", icon: "xlsfile" },
    // { value: "json", name: "JSON", icon: "file" },
    // { value: "xlsx", name: "XLSX", icon: "xlsxfile" },
    // { value: "ods", name: "ODS", icon: "file" },
    // { value: "docx", name: "DOCX", icon: "docxfile" },
    // { value: "odt", name: "ODT", icon: "file" },
    // { value: "rtf", name: "RTF", icon: "rtffile" },
    // { value: "xml", name: "XML", icon: "variable" },
    // { value: "html", name: "HTML", icon: "variable" },
  ];

  constructor(private reportsService: ReportsService) { }

  ngOnInit(): void {
  }

  onItemClick(event) {
    let outputType = event.itemData.name;
    this.reportsService.printListReport(this.url, this.reportCode, outputType, [], this.filter, this.sort);
  }
}
